export default __webpack_public_path__ + "static/media/doge.a9424efa.png";